import React, { useEffect, useState } from 'react'
import axios from 'axios'
import styled from 'styled-components'
import { FadeLoader } from 'react-spinners'
import { PAGE_LOAD_DELAY_MS } from '../../constants'
import { LockClosedIcon as _LockClosedIcon } from '@radix-ui/react-icons'

interface IBookPageProps {
  bookId: string
  pageIndex: number
  style: any
  hasPermission: boolean
}

export const BookPage: React.FC<IBookPageProps> = ({ bookId, pageIndex, style, hasPermission }) => {
  const [image, setImage] = useState<any>('')

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      axios
        .get(`/api/books/${bookId}/pages/${pageIndex}/img/`, {
          responseType: 'blob'
        })
        .then(response => setImage(URL.createObjectURL(response.data)))
    }, PAGE_LOAD_DELAY_MS)

    return () => clearTimeout(timeoutId)
  }, [pageIndex, bookId])

  return (
    <Wrapper style={style}>
      <InnerWrapper>
        {image ? <img alt={`Страница ${pageIndex}`} src={image}/> : <FadeLoader color="rgb(201, 201, 208)"/>}
        {image && !hasPermission && <LockClosedIcon/>}
      </InnerWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  justify-content: center;
`

const InnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    60% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  img {
    border: 0.5px solid rgb(201, 201, 208);
    height: 100%;
    display: block;
    animation: fade-in ease 60ms;
  }
`

const LockClosedIcon = styled(_LockClosedIcon)`
  position: absolute;
  left: 50%;
  right: 50%;
  transform: translate(-50%, -50%) scale(2);
  padding: 4px;
  border-radius: 2px;
  color: var(--gray-a10);
  background-color: var(--yellow-a4);
`